'use client';

import { css } from '@bts-web/utils-style-engine';
import { useDrawerMetadata } from '../ModalDrawerContext/ModalDrawerContext';
import { ReactNode } from 'react';
import { FilledDismiss } from '../../svgIcons';

export const CloseDrawerButton = ({
  icon = <FilledDismiss size={24} />,
}: {
  icon?: ReactNode;
}) => {
  const { closeThisDrawer } = useDrawerMetadata();

  return (
    <button
      data-testid="close-transaction-drawer-button"
      className={css({
        py: 'small',
        borderRadius: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        marginInlineStart: 'auto',
      })}
      disabled={false}
      onClick={closeThisDrawer}
    >
      {icon}
    </button>
  );
};
